<template>
  <VApp>
    <VContent>
      <VContainer
        fluid
        fill-height
      >
        <VLayout
          align-center
          justify-center
        >
          <VFlex
            md4
            sm8
            xs12
          >
            <RegistrationCard />
          </VFlex>
        </VLayout>
      </VContainer>
    </VContent>
  </VApp>
</template>

<script>
import UserRegistrationCard from '@/components/UserRegistrationCard'
export default {
  name: 'RegistrationPage',
  components: {
    RegistrationCard: UserRegistrationCard
  }
}
</script>

<style scoped>

</style>
